import { ITriggerType } from 'Components/flowChart/components/NodePreview/components/NodeActionBased/types';

export const TRIGGER_TIME_LABEL: Record<ITriggerType, string> = {
	all: 'All time',
	time_of_week: 'Specific days of the week',
};
